import { AppBrandLink, AppNavigation, AppNavigationHeader } from '@ms/yammer-features-app-navigation';
import NavigationCommunities from '@ms/yammer-web-components/dist/navigation/NavigationCommunities';
import AutocompleteAriaHost from '@ms/yammer-web-core-ui/dist/components/AutocompleteAriaHost';
import { useUIFeatures } from '@ms/yammer-web-ui-features/dist/features';
import { useIsTeamsPersonalApp } from 'hooks/selectors';
import React, { ReactNode, useCallback } from 'react';

import AppSearchNavPhase1 from '../../AppSearchNavPhase1';
import { UserProfileMenuButton } from '../../UserProfileMenuButton';
import VivaSuiteNav from '../../VivaSuiteNav';

import { useHomeLinkActionButtons } from './useHomeLinkActionButtons';

type UseLeftSidebarCallback = () => () => ReactNode;
export const useLeftSidebarCallback: UseLeftSidebarCallback = () => {
  const isLeftSidebarEnabled = useUIFeatures((features) => features.navigation?.leftSidebar);
  const homeLinkActionButtons = useHomeLinkActionButtons();
  const isTeamsPersonalApp = useIsTeamsPersonalApp();

  return useCallback(() => {
    const vivaSuiteNav = isTeamsPersonalApp ? <VivaSuiteNav /> : null;

    return isLeftSidebarEnabled ? (
      <AppNavigation
        communitiesNavLinksContent={<NavigationCommunities />}
        header={
          <AppNavigationHeader
            title={<AppBrandLink />}
            contextMenu={vivaSuiteNav}
            searchInput={
              <AutocompleteAriaHost>
                <AppSearchNavPhase1 />
              </AutocompleteAriaHost>
            }
          />
        }
        homeLinkActionButtons={homeLinkActionButtons}
        userProfileLinkActionButtons={[<UserProfileMenuButton key="UserProfileMenuButton" />]}
      />
    ) : null;
  }, [homeLinkActionButtons, isLeftSidebarEnabled, isTeamsPersonalApp]);
};
